import { authHeader, handleResponse } from '../helpers'

export const invoiceService = {
    getInvoice,
    createInvoice,
};

function getInvoice(invoiceId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/invoice/${invoiceId}`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function createInvoice(taskIds) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: taskIds
    };
    return fetch(process.env.VUE_APP_API_URL + `/invoice`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}
